import { Button } from '@blueprintjs/core';
import { mdiAutoFix } from '@mdi/js';
import Icon from '@mdi/react';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { dialogOpened } from 'uf/location-analysis/locationAnalysisDialogSlice';
import tw from 'uf/tailwindcss-classnames';
import { IconSizeNew } from 'uf/ui/base/icon';
import styles from './LocationAnalysisButton.module.css';

interface Props {
  className?: string;
  minimal?: boolean;
}

const LocationAnalysisButton = ({ className, minimal }: Props) => {
  const dispatch = useDispatch();
  const handleOpen = () => {
    dispatch(dialogOpened());
  };
  return (
    <Button
      data-testid="location-analysis-button"
      className={classNames(
        tw('tw-px-3', 'tw-items-start', 'tw-rounded-md', 'tw-shadow-none'),
        styles.button,
        className,
      )}
      alignText="left"
      icon={<Icon path={mdiAutoFix} size={IconSizeNew.SMALL} color="#0EA8CA" />}
      onClick={handleOpen}>
      <h4>
        Upload assets to{' '}
        <span className={tw('tw-font-bold')}>Location Analysis Service</span>
      </h4>
      {!minimal && (
        <>
          <p className={tw('tw-text-gray-700')}>
            Receive insight layers about these assets within 2 business days.
          </p>
          <h6 className={classNames(tw('tw-font-bold'), styles.callOut)}>
            (FEATURED SERVICE)
          </h6>
        </>
      )}
    </Button>
  );
};

export default LocationAnalysisButton;
